import {
  refreshProviderDomainsRequest,
  refreshAuthRequest,
} from 'features/authentication/store/actions';

export const initApplication = () => {
  return (dispatch) =>
    Promise.all([dispatch(refreshAuthRequest()), dispatch(refreshProviderDomainsRequest())]);
};
